<div class="section-top" *ngIf="!viewMode">
  <div style="flex:1;"></div>
  <div class="currencies" *ngIf="!readOnly && budgetCurrency && section?.settings.currency && section?.settings.currency !== budgetCurrency">
    <div class="currency-details">Budget Currency: <span class="currency">{{ budgetCurrency }}</span></div>
    <div class="currency-details">Section Currency: <span class="currency">{{ section.settings.currency }}</span></div>
    <div class="conversion-label">Conversion Rate: </div>
    <joi-input 
      [(model)]="section.settings.conversionRate" 
      [fixedWidth]="true"
      [placeholder]="'Conversion rate'"
      [allowableCharacters]="'0123456789.'" 
      [disabled]="readOnly"
      (joiChange)="updateConversionRate()"
    ></joi-input>
  </div>
  <action-button class="updates" *ngIf="!!hasChanges && !viewMode" [text]="updatesLabel" (click)="checkUpdates($event)"></action-button>
  <action-button *ngIf="!section.linkId && !readOnly"
    class="settingsButton"
    [text]="'SECTION SETTINGS'" 
    (click)="changeSettings($event)"
  ></action-button>
  <dropdown class="manageDropdown"
    *ngIf="!!linkDropdownOptions"
    [selections]="linkDropdownOptions"
    [selected]="null"
    [disableSelect]="true"
    [null_text]="'Manage Link'"
    (select)="linkDropdownSelection.emit($event.id)"
  ></dropdown>
</div>

<div class="title-bar" *ngIf="!hideTitle" [ngClass]="{ readOnly: readOnly }">
  <div style="flex:1"></div>
  <up-down-arrows *ngIf="(!readOnly && !single) || allowSectionOrdering" [hideUp]="first" [hideDown]="last" (moveUp)="moveUp.emit()" (moveDown)="moveDown.emit()"></up-down-arrows>
  <delete-button *ngIf="!readOnly && !single" [deleteTitle]="deleteTitle" [deleteText]="deleteText" (delete)="deleteSection.emit()"></delete-button>
  <joi-input #sectionTitle class="big-title" [type]="'textarea'" [(model)]="section.name" [placeholder]="readOnly ? 'Unnamed Section' : 'Section name...'" (joiChange)="saveSection.emit(section); nameChange.emit($event)" [disabled]="readOnly"></joi-input>
</div>
<budget-grid 
  *ngIf="gridData?.length" 
  #budgetGrid
  [ngClass]="{ flush: !hideTitle }"
  [readOnly]="readOnly" 
  [showDelete]="!readOnly && canDeleteLines"
  [hiddenColumns]="hiddenColumns"
  [columns]="usedColumns" 
  [rows]="gridData"
  [fullWidth]="fullWidth"
  [canAddItems]="canAddItems"
  (saveRows)="saveRows($event)"
  (saveCell)="saveCell($event)"
  (addItem)="addItem.emit($event)"
></budget-grid>
<div class="bottom" [ngClass]="{ fullWidth: fullWidth }" >
  <button *ngIf="!readOnly && !!canAddLines" class="secondary" (click)="addLine()">+ ADD LINE</button>
  <div class="totals">
    <ng-container *ngIf="section.discount">
      <div class="total-label">Discount:</div>
      <div class="total-amount">({{ section.discount | prettyNumbers }})</div>
    </ng-container>
    <ng-container *ngIf="section.fees">
      <div class="total-label">Fees:</div>
      <div class="total-amount">{{ section.fees | prettyNumbers }}</div>
    </ng-container>
    <ng-container *ngIf="section.subTotal !== section.total">
      <div class="total-label" >Subtotal:</div>
      <div class="total-amount">{{ section.subTotal | prettyNumbers }}</div>
    </ng-container>
    <ng-container *ngIf="section.tax">
      <div class="total-label">Tax:</div>
      <div class="total-amount">{{ section.tax | prettyNumbers }}</div>
    </ng-container>
    <div class="total-label bold">Section Total:</div>
    <div class="total-amount">{{ section.total | prettyNumbers }}</div>
  </div>
</div>

<expanding-wrapper *ngIf="!!section.schedule && (!readOnly || !!section.files?.length) && !isRevenue" class="schedule"
  [title]="'File Links (' + (section.files?.length || 0) + ')'"
  [borderGreyOnCollapse]="true"
  [padded]="true"
><file-handler 
  [readfilesonly]="readOnly"
  [data]="{ files: section.files || [] }"
  [showNoFilesMessage]="!section.files?.length"
  [namePlaceholder]="'File Link'"
  [noFilesMessage]="'No file links'"
  [hideByline]="true"
  (dataChange)="saveFiles($event)"
  ></file-handler>
</expanding-wrapper>

<expanding-wrapper *ngIf="!!section.schedule && (!readOnly || !!section.schedule.items.length) && !isRevenue && !!scheduleGridData" class="schedule"
  [title]="'Payment Schedule (' + (section.schedule?.items.length || 0) + ')'"
  [borderGreyOnCollapse]="true"
  [padded]="true"
><budget-schedule 
  [schedule]="section?.schedule"
  [gridData]="scheduleGridData"
  [readOnly]="readOnly"
  [paymentSchedule]="isRevenue"
  [fullWidth]="fullWidth"
  [costId]="section.id"
  (saveSchedule)="saveSchedule($event)"
  ></budget-schedule>
</expanding-wrapper>

